export const COLOR_PRIMARY = "#1a2543"
export const COLOR_SECONDARY = "#00d8ac"

export const COLOR_WHITE_SECONDARY = "#F8F8F8"
